import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './app/App';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AppProvider } from './contexts/AppContext';

AOS.init();
/**
 * The root element of the application.
 */
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

/**
 * The root element of the application.
 */
const root = createRoot(container);

if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.warn = () => { }
  console.error = () => { }
  console.info = () => { }
  console.debug = () => { }
  console.trace = () => { }
  console.table = () => { }
  console.group = () => { }
  console.groupCollapsed = () => { }
  console.groupEnd = () => { }
  console.time = () => { }
  console.timeLog = () => { }
  console.timeEnd = () => { }
  console.count = () => { }
  console.clear = () => { }
  console.dir = () => { }
  console.dirxml = () => { }
  console.assert = () => { }
  console.profile = () => { }
  console.profileEnd = () => { }
  console.timeStamp = () => { }
  console.table = () => { }
  console.countReset = () => { }
}
root.render(
  <AppProvider>
    <App />
  </AppProvider>
);


